<!-- Standardized List Page Skeleton - matches customers-list layout -->
<div class="list-page-skeleton mt-2">
  <!-- Main Content Layout with Flex -->
  <div class="main-layout">
    <!-- Sidebar Toggle Area (always visible) -->
    <div class="sidebar-toggle-area">
      <p-skeleton width="32px" height="32px" borderRadius="6px" />

      <!-- Collapsed State Controls -->
      @if (sidebarCollapsed) {
        <div class="collapsed-controls">
          <p-skeleton
            width="40px"
            height="40px"
            borderRadius="6px"
            styleClass="mb-2"
          />
          <p-skeleton width="32px" height="32px" borderRadius="6px" />
        </div>
      }
    </div>

    <!-- Filter Sidebar -->
    <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed">
      <!-- Filter Content -->
      @if (!sidebarCollapsed) {
        <div class="sidebar-content">
          <div class="p-4 overflow-auto h-full">
            <!-- Search Bar Skeleton -->
            <div class="mb-6">
              <p-skeleton width="100%" height="40px" borderRadius="6px" />
            </div>

            <!-- Filter Fields based on preset -->
            @switch (filterPresetName) {
              @case ("paymentIntegrations") {
                <!-- ID Filter -->
                <div class="mb-6">
                  <p-skeleton width="30px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Provider Filter -->
                <div class="mb-6">
                  <p-skeleton width="100px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Mode Filter -->
                <div class="mb-6">
                  <p-skeleton width="60px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Status Filter -->
                <div class="mb-6">
                  <p-skeleton width="70px" height="16px" styleClass="mb-2" />
                  <div class="flex gap-1">
                    <p-skeleton width="50px" height="32px" borderRadius="6px" />
                    <p-skeleton width="50px" height="32px" borderRadius="6px" />
                    <p-skeleton width="50px" height="32px" borderRadius="6px" />
                  </div>
                </div>
              }
              @case ("customers") {
                <!-- Include Deleted Filter -->
                <div class="mb-6">
                  <p-skeleton width="120px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Date Filters -->
                <div class="mb-6">
                  <p-skeleton width="100px" height="16px" styleClass="mb-3" />
                  <div class="mb-3">
                    <p-skeleton width="120px" height="14px" styleClass="mb-2" />
                    <p-skeleton width="100%" height="36px" borderRadius="6px" />
                  </div>
                </div>
              }
              @case ("scheduledOrders") {
                <!-- ID Filter -->
                <div class="mb-6">
                  <p-skeleton width="50px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Status Filter -->
                <div class="mb-6">
                  <p-skeleton width="80px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Date Range Filter -->
                <div class="mb-6">
                  <p-skeleton width="100px" height="16px" styleClass="mb-3" />
                  <div class="mb-3">
                    <p-skeleton width="60px" height="14px" styleClass="mb-2" />
                    <p-skeleton width="100%" height="36px" borderRadius="6px" />
                  </div>
                  <div>
                    <p-skeleton width="60px" height="14px" styleClass="mb-2" />
                    <p-skeleton width="100%" height="36px" borderRadius="6px" />
                  </div>
                </div>
              }
              @case ("products") {
                <!-- ID Filter -->
                <div class="mb-6">
                  <p-skeleton width="50px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Availability Filter -->
                <div class="mb-6">
                  <p-skeleton width="80px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Product Group Filter -->
                <div class="mb-6">
                  <p-skeleton width="100px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
              }
              @case ("coupons") {
                <!-- Actions Filter -->
                <div class="mb-6">
                  <p-skeleton width="60px" height="16px" styleClass="mb-3" />
                  <div class="flex flex-column gap-2">
                    <p-skeleton width="100%" height="40px" borderRadius="6px" />
                    <p-skeleton width="100%" height="40px" borderRadius="6px" />
                  </div>
                </div>
              }
              @case ("quickLinks") {
                <!-- Status Filter -->
                <div class="mb-6">
                  <p-skeleton width="50px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Action Type Filter -->
                <div class="mb-6">
                  <p-skeleton width="90px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <!-- Usage Limit Filter -->
                <div class="mb-6">
                  <p-skeleton width="80px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
              }
              @case ("productGroups") {
                <!-- Just search, minimal filters -->
              }
              @case ("retentionWorkflows") {
                <!-- Status Filter -->
                <div class="mb-6">
                  <p-skeleton width="50px" height="16px" styleClass="mb-3" />
                  @for (i of [1, 2]; track i) {
                    <div class="flex align-items-center gap-2 mb-2">
                      <p-skeleton
                        width="16px"
                        height="16px"
                        borderRadius="4px"
                      />
                      <p-skeleton width="80px" height="14px" />
                    </div>
                  }
                </div>
                <!-- Triggered By Filter -->
                <div class="mb-6">
                  <p-skeleton width="80px" height="16px" styleClass="mb-3" />
                  @for (i of [1, 2]; track i) {
                    <div class="flex align-items-center gap-2 mb-2">
                      <p-skeleton
                        width="16px"
                        height="16px"
                        borderRadius="4px"
                      />
                      <p-skeleton width="60px" height="14px" />
                    </div>
                  }
                </div>
              }
              @default {
                <!-- Default filters -->
                <div class="mb-6">
                  <p-skeleton width="80px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <div class="mb-6">
                  <p-skeleton width="100px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
                <div class="mb-6">
                  <p-skeleton width="60px" height="16px" styleClass="mb-2" />
                  <p-skeleton width="100%" height="40px" borderRadius="6px" />
                </div>
              }
            }

            <!-- Action Buttons -->
            <div class="flex gap-2 mt-6">
              <p-skeleton width="80px" height="32px" borderRadius="6px" />
              <p-skeleton width="100px" height="32px" borderRadius="6px" />
            </div>
          </div>
        </div>
      }
    </div>

    <!-- Main Content Area -->
    <div class="content-area" [class.sidebar-open]="!sidebarCollapsed">
      <!-- Compact Toolbar -->
      @if (showToolbar) {
        <div
          class="content-toolbar surface-section border-bottom-1 surface-border"
        >
          <div class="flex align-items-center justify-content-between p-3">
            <div class="flex align-items-center gap-3 flex-1">
              <p-skeleton width="120px" height="16px" />
            </div>
          </div>
        </div>
      }

      <!-- Table Container -->
      <div class="table-container">
        <!-- Table Header -->
        <div
          class="table-header surface-ground border-round-top p-2 border-bottom-1 surface-border w-full"
        >
          <div class="flex align-items-center gap-2 w-full">
            @switch (tablePresetName) {
              @case ("paymentIntegrations") {
                <!-- ID Column -->
                <div style="width: 4rem; flex-shrink: 0">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Provider Column -->
                <div style="min-width: 150px; flex: 1">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- API Account Column -->
                <div style="min-width: 180px; flex: 1">
                  <p-skeleton width="80px" height="14px" />
                </div>
                <!-- API Key Column -->
                <div style="min-width: 180px; flex: 1">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Mode Column -->
                <div style="width: 80px; text-align: center">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Created Column -->
                <div style="width: 100px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("customers") {
                <!-- ID Column -->
                <div style="width: 3rem; flex-shrink: 0">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="min-width: 150px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Email Column -->
                <div style="min-width: 200px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Active/Total Column -->
                <div style="width: 100px; text-align: center">
                  <p-skeleton width="70px" height="14px" />
                </div>
                <!-- Paused Column -->
                <div style="width: 100px; text-align: center">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- LTV Column -->
                <div style="width: 120px; text-align: right">
                  <p-skeleton width="30px" height="14px" />
                </div>
                <!-- Next Order Column -->
                <div style="width: 120px">
                  <p-skeleton width="70px" height="14px" />
                </div>
                <!-- Created Column -->
                <div style="width: 120px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("scheduledOrders") {
                <!-- ID Column -->
                <div style="width: 3rem; flex-shrink: 0">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Status Column -->
                <div style="width: 70px">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Customer Column -->
                <div style="min-width: 120px; flex: 1">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Email Column -->
                <div style="min-width: 160px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Frequency Column -->
                <div style="width: 70px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Next Order Column -->
                <div style="width: 80px">
                  <p-skeleton width="70px" height="14px" />
                </div>
                <!-- Last Order Column -->
                <div style="width: 80px">
                  <p-skeleton width="70px" height="14px" />
                </div>
                <!-- Items Column -->
                <div style="width: 40px; text-align: center">
                  <p-skeleton width="30px" height="14px" />
                </div>
                <!-- Value Column -->
                <div style="width: 60px">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("products") {
                <!-- ID Column -->
                <div style="width: 3rem; flex-shrink: 0">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="min-width: 120px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Availability Column -->
                <div style="width: 50px">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Type Column -->
                <div style="width: 70px">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Price Column -->
                <div style="width: 50px">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Sale Price Column -->
                <div style="width: 60px">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Stock Column -->
                <div style="width: 30px">
                  <p-skeleton width="30px" height="14px" />
                </div>
                <!-- Product Group Column -->
                <div style="width: 130px">
                  <p-skeleton width="80px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("coupons") {
                <!-- Code Column -->
                <div style="width: 150px; flex-shrink: 0">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="width: 200px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Type Column -->
                <div style="width: 180px">
                  <p-skeleton width="35px" height="14px" />
                </div>
                <!-- Amount Column -->
                <div style="width: 100px">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Expires Column -->
                <div style="width: 140px">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Uses Column -->
                <div style="width: 100px">
                  <p-skeleton width="35px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 80px; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("quickLinks") {
                <!-- Expand Column -->
                <div style="width: 2.5rem; flex-shrink: 0">
                  <p-skeleton width="24px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="flex: 1; min-width: 180px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Slug Column -->
                <div style="flex: 1; min-width: 180px">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Action Type Column -->
                <div style="width: 180px">
                  <p-skeleton width="90px" height="14px" />
                </div>
                <!-- Enabled Column -->
                <div style="width: 120px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Usage Column -->
                <div style="flex: 1; min-width: 150px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- One-time Use Column -->
                <div style="width: 140px">
                  <p-skeleton width="80px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
              @case ("productGroups") {
                <!-- Expand Column -->
                <div style="width: 3rem" class="flex justify-content-center">
                  <p-skeleton width="18px" height="18px" borderRadius="50%" />
                </div>
                <!-- ID Column -->
                <div style="width: 5rem">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="min-width: 150px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Products Column -->
                <div style="width: 100px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Created Column -->
                <div style="width: 120px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Updated Column -->
                <div style="width: 120px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem">
                    <p-skeleton width="16px" height="16px" />
                  </div>
                }
              }
              @case ("retentionWorkflows") {
                <!-- Expand Column -->
                <div style="width: 2.5rem">
                  <p-skeleton width="16px" height="16px" borderRadius="50%" />
                </div>
                <!-- ID Column -->
                <div style="width: 4rem">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <!-- Name Column -->
                <div style="min-width: 200px; flex: 1">
                  <p-skeleton width="40px" height="14px" />
                </div>
                <!-- Status Column -->
                <div style="width: 6rem">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Enabled Column -->
                <div style="width: 5rem; text-align: center">
                  <p-skeleton width="50px" height="14px" />
                </div>
                <!-- Triggered By Column -->
                <div style="width: 7rem">
                  <p-skeleton width="55px" height="14px" />
                </div>
                <!-- Created Column -->
                <div style="width: 8rem">
                  <p-skeleton width="80px" height="14px" />
                </div>
                <!-- Updated Column -->
                <div style="width: 8rem">
                  <p-skeleton width="80px" height="14px" />
                </div>
                <!-- Actions Column -->
                @if (showActions) {
                  <div style="width: 3rem; text-align: center">
                    <p-skeleton width="24px" height="14px" />
                  </div>
                }
              }
              @default {
                <!-- Default table header -->
                <div style="width: 3rem; flex-shrink: 0">
                  <p-skeleton width="20px" height="14px" />
                </div>
                <div style="min-width: 150px; flex: 1">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <div style="min-width: 150px; flex: 1">
                  <p-skeleton width="60px" height="14px" />
                </div>
                <div style="width: 100px">
                  <p-skeleton width="60px" height="14px" />
                </div>
                @if (showActions) {
                  <div style="width: 3rem; text-align: center; flex-shrink: 0">
                    <p-skeleton width="50px" height="14px" />
                  </div>
                }
              }
            }
          </div>
        </div>

        <!-- Table Rows -->
        <div class="table-body surface-0 border-round-bottom w-full">
          @for (row of rowsArray; track row) {
            <div class="p-2 border-bottom-1 surface-border w-full">
              <div class="flex align-items-center gap-2 w-full">
                @switch (tablePresetName) {
                  @case ("paymentIntegrations") {
                    <!-- ID -->
                    <div style="width: 4rem; flex-shrink: 0">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <!-- Provider -->
                    <div style="min-width: 150px; flex: 1">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <!-- API Account -->
                    <div style="min-width: 180px; flex: 1">
                      <p-skeleton width="140px" height="14px" />
                    </div>
                    <!-- API Key -->
                    <div style="min-width: 180px; flex: 1">
                      <p-skeleton width="120px" height="14px" />
                    </div>
                    <!-- Mode -->
                    <div style="width: 80px; text-align: center">
                      <p-skeleton
                        width="50px"
                        height="20px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- Created -->
                    <div style="width: 100px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 3rem; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("customers") {
                    <!-- ID -->
                    <div style="width: 3rem; flex-shrink: 0">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <!-- Name -->
                    <div style="min-width: 150px; flex: 1">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <!-- Email -->
                    <div style="min-width: 200px; flex: 1">
                      <p-skeleton width="140px" height="14px" />
                    </div>
                    <!-- Active/Total -->
                    <div style="width: 100px; text-align: center">
                      <p-skeleton
                        width="40px"
                        height="20px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- Paused -->
                    <div style="width: 100px; text-align: center">
                      <p-skeleton
                        width="24px"
                        height="20px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- LTV -->
                    <div style="width: 120px; text-align: right">
                      <p-skeleton width="60px" height="14px" />
                    </div>
                    <!-- Next Order -->
                    <div style="width: 120px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Created -->
                    <div style="width: 120px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 3rem; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("scheduledOrders") {
                    <!-- ID -->
                    <div style="width: 3rem; flex-shrink: 0">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <!-- Status -->
                    <div style="width: 70px">
                      <p-skeleton
                        width="60px"
                        height="20px"
                        borderRadius="4px"
                      />
                    </div>
                    <!-- Customer -->
                    <div style="min-width: 120px; flex: 1">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <!-- Email -->
                    <div style="min-width: 160px; flex: 1">
                      <p-skeleton width="140px" height="14px" />
                    </div>
                    <!-- Frequency -->
                    <div style="width: 70px">
                      <p-skeleton width="50px" height="14px" />
                    </div>
                    <!-- Next Order -->
                    <div style="width: 80px">
                      <p-skeleton width="70px" height="14px" />
                    </div>
                    <!-- Last Order -->
                    <div style="width: 80px">
                      <p-skeleton width="70px" height="14px" />
                    </div>
                    <!-- Items -->
                    <div style="width: 40px; text-align: center">
                      <p-skeleton width="20px" height="14px" />
                    </div>
                    <!-- Value -->
                    <div style="width: 60px">
                      <p-skeleton width="50px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 3rem; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("products") {
                    <!-- ID -->
                    <div style="width: 3rem; flex-shrink: 0">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <!-- Name -->
                    <div style="min-width: 120px; flex: 1">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <!-- Availability -->
                    <div style="width: 50px">
                      <p-skeleton
                        width="40px"
                        height="20px"
                        borderRadius="4px"
                      />
                    </div>
                    <!-- Type -->
                    <div style="width: 70px">
                      <p-skeleton
                        width="50px"
                        height="20px"
                        borderRadius="4px"
                      />
                    </div>
                    <!-- Price -->
                    <div style="width: 50px">
                      <p-skeleton width="40px" height="14px" />
                    </div>
                    <!-- Sale Price -->
                    <div style="width: 60px">
                      <p-skeleton width="40px" height="14px" />
                    </div>
                    <!-- Stock -->
                    <div style="width: 30px">
                      <p-skeleton width="20px" height="14px" />
                    </div>
                    <!-- Product Group -->
                    <div style="width: 130px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 3rem; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("coupons") {
                    <!-- Code -->
                    <div style="width: 150px; flex-shrink: 0">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Name -->
                    <div style="width: 200px; flex: 1">
                      <p-skeleton width="120px" height="14px" />
                    </div>
                    <!-- Type -->
                    <div style="width: 180px">
                      <p-skeleton
                        width="100px"
                        height="22px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- Amount -->
                    <div style="width: 100px">
                      <p-skeleton width="50px" height="14px" />
                    </div>
                    <!-- Expires -->
                    <div style="width: 140px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Uses -->
                    <div style="width: 100px">
                      <p-skeleton width="40px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 80px; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("quickLinks") {
                    <!-- Expand Icon -->
                    <div style="width: 2.5rem; flex-shrink: 0">
                      <p-skeleton
                        width="24px"
                        height="24px"
                        borderRadius="50%"
                      />
                    </div>
                    <!-- Name -->
                    <div style="flex: 1; min-width: 180px">
                      <p-skeleton width="120px" height="14px" />
                    </div>
                    <!-- Slug -->
                    <div style="flex: 1; min-width: 180px">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <!-- Action Type -->
                    <div style="width: 180px">
                      <div class="flex align-items-center gap-1">
                        <p-skeleton
                          width="16px"
                          height="16px"
                          borderRadius="50%"
                        />
                        <p-skeleton width="80px" height="14px" />
                      </div>
                    </div>
                    <!-- Enabled Toggle -->
                    <div style="width: 120px">
                      <p-skeleton
                        width="36px"
                        height="20px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- Usage -->
                    <div style="flex: 1; min-width: 150px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- One-time Use -->
                    <div style="width: 140px">
                      <p-skeleton
                        width="24px"
                        height="24px"
                        borderRadius="4px"
                      />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div style="width: 3rem; flex-shrink: 0">
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("productGroups") {
                    <!-- Expand -->
                    <div
                      style="width: 3rem"
                      class="flex justify-content-center"
                    >
                      <p-skeleton
                        width="18px"
                        height="18px"
                        borderRadius="50%"
                      />
                    </div>
                    <!-- ID -->
                    <div style="width: 5rem">
                      <p-skeleton width="2.5rem" height="14px" />
                    </div>
                    <!-- Name -->
                    <div style="min-width: 150px; flex: 1">
                      <p-skeleton width="80%" height="14px" />
                    </div>
                    <!-- Products Count -->
                    <div
                      style="width: 100px"
                      class="flex justify-content-center"
                    >
                      <p-skeleton
                        width="2rem"
                        height="1.25rem"
                        borderRadius="9999px"
                      />
                    </div>
                    <!-- Created -->
                    <div style="width: 120px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Updated -->
                    <div style="width: 120px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div
                        style="width: 3rem"
                        class="flex justify-content-center"
                      >
                        <p-skeleton
                          width="18px"
                          height="18px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @case ("retentionWorkflows") {
                    <!-- Expand -->
                    <div style="width: 2.5rem">
                      <p-skeleton
                        width="16px"
                        height="16px"
                        borderRadius="50%"
                      />
                    </div>
                    <!-- ID -->
                    <div style="width: 4rem">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <!-- Name -->
                    <div style="min-width: 200px; flex: 1">
                      <p-skeleton width="120px" height="14px" />
                    </div>
                    <!-- Status -->
                    <div style="width: 6rem">
                      <p-skeleton
                        width="50px"
                        height="20px"
                        borderRadius="4px"
                      />
                    </div>
                    <!-- Enabled -->
                    <div style="width: 5rem; text-align: center">
                      <p-skeleton
                        width="36px"
                        height="20px"
                        borderRadius="12px"
                      />
                    </div>
                    <!-- Triggered By -->
                    <div style="width: 7rem">
                      <p-skeleton width="55px" height="14px" />
                    </div>
                    <!-- Created -->
                    <div style="width: 8rem">
                      <p-skeleton width="70px" height="14px" />
                    </div>
                    <!-- Updated -->
                    <div style="width: 8rem">
                      <p-skeleton width="70px" height="14px" />
                    </div>
                    <!-- Actions -->
                    @if (showActions) {
                      <div style="width: 3rem; text-align: center">
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                  @default {
                    <!-- Default table row -->
                    <div style="width: 3rem; flex-shrink: 0">
                      <p-skeleton width="30px" height="14px" />
                    </div>
                    <div style="min-width: 150px; flex: 1">
                      <p-skeleton width="100px" height="14px" />
                    </div>
                    <div style="min-width: 150px; flex: 1">
                      <p-skeleton width="120px" height="14px" />
                    </div>
                    <div style="width: 100px">
                      <p-skeleton width="80px" height="14px" />
                    </div>
                    @if (showActions) {
                      <div
                        style="width: 3rem; text-align: center; flex-shrink: 0"
                      >
                        <p-skeleton
                          width="24px"
                          height="24px"
                          borderRadius="50%"
                        />
                      </div>
                    }
                  }
                }
              </div>
            </div>
          }
        </div>

        <!-- Pagination Skeleton -->
        @if (showPagination) {
          <div
            class="table-pagination flex align-items-center justify-content-between p-3 border-top-1 surface-border w-full"
          >
            <div class="flex-1">
              <p-skeleton width="200px" height="14px" />
            </div>
            <div class="flex gap-2 align-items-center">
              <p-skeleton width="50px" height="28px" borderRadius="6px" />
              <p-skeleton width="28px" height="28px" borderRadius="6px" />
              <p-skeleton width="28px" height="28px" borderRadius="6px" />
              <p-skeleton width="28px" height="28px" borderRadius="6px" />
              <p-skeleton width="28px" height="28px" borderRadius="6px" />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
